import React from 'react';

import { useIntl } from 'react-intl-next';

import Tag from '@atlaskit/tag';
import { ResponderAvatar, useResponderNames } from '@atlassian/eoc-responder-names';
import { filterNoOne } from '@atlassian/eoc-schedule-common';

import { getResponder } from '../../../../utils/responder';

import { type ResponderTagProps } from './types';

const ResponderTag = ({ responder }: ResponderTagProps) => {
	const intlApi = useIntl();

	const [user] = useResponderNames(filterNoOne([responder]));

	// TODO: handle error and loading. See: TARDIS-7446
	const { name } = getResponder(responder, user, intlApi);

	const isNoOne = responder.type === 'noone';

	return (
		<Tag
			text={name}
			appearance="rounded"
			isRemovable={false}
			elemBefore={
				isNoOne ? null : <ResponderAvatar appearance="circle" size="xsmall" responder={user} />
			}
		/>
	);
};

export { ResponderTag };
